var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('comp-6-scenario',{attrs:{"page":7,"scenario":'scenario1'}})}
var staticRenderFns = []

export { render, staticRenderFns }